import React, { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import { FaCheck, FaRandom, FaTimes } from "react-icons/fa";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import myToast from "../Utils/MyToast";
import COLORS from "../resources/colors/COLORS";
import "../css/Admin_css/admin-customize.css";

const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

const DIALOG_STYLES = `
  .modal.show { display: block !important; opacity: 1 !important; }
  .modal.fade.show { opacity: 1 !important; }
  .mdl-batch-shift-dialog.modal-dialog {
    z-index: 1050 !important;
    position: relative;
    margin: 0.45rem auto 1rem;
    max-width: 760px;
  }
  .mdl-batch-shift-dialog.modal-dialog.modal-dialog-centered {
    min-height: calc(100% - 1rem);
  }
  .modal-backdrop { z-index: 1040 !important; }
  .modal-backdrop.show { opacity: 0.5 !important; }
  .mdl-batch-shift-dialog .modal-content {
    z-index: 1051 !important;
    position: relative;
    border-radius: 16px;
    overflow: hidden;
    border: 2px solid rgba(179, 229, 252, 0.55);
    box-shadow: 0 12px 28px rgba(2, 136, 209, 0.14);
    background: #fff;
  }
  .mdl-batch-shift-dialog .modal-header {
    border: none;
    padding: 12px 16px;
    background: linear-gradient(135deg, #03a9f4 0%, #0288d1 55%, #01579b 100%);
  }
  .mdl-batch-shift-dialog .modal-header .close {
    color: #fff;
    opacity: 0.92;
    text-shadow: none;
    font-size: 1.35rem;
    font-weight: 400;
    padding: 0.35rem 0.55rem;
  }
  .mdl-batch-shift-dialog .modal-body {
    padding: 12px 14px 10px;
    background: #fff;
  }
  .mdl-batch-shift-dialog .modal-footer {
    border-top: 1px solid #e1f5fe;
    padding: 10px 14px;
    background: #f0f9ff;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
  .mbs-title {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin: 0;
    color: #fff;
    width: 100%;
    padding-right: 18px;
  }
  .mbs-title__icon {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(255,255,255,0.18);
    border: 1px solid rgba(255,255,255,0.35);
    font-size: 15px;
  }
  .mbs-title__main { font-size: 16px; font-weight: 800; line-height: 1.2; }
  .mbs-title__sub {
    margin-top: 2px;
    font-size: 11px;
    font-weight: 500;
    color: rgba(255,255,255,0.88);
  }
  .mbs-filters {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    border: 2px solid ${COLORS.primary_color_shade3};
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 10px;
  }
  .mbs-filter {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    min-width: 0;
  }
  .mbs-filter--board {
    background: linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade6} 100%);
  }
  .mbs-filter--medium {
    background: linear-gradient(135deg, ${COLORS.primary_color_shade6} 0%, ${COLORS.primary_color_shade7} 100%);
    border-left: 2px solid rgba(255,255,255,0.35);
  }
  .mbs-filter__label {
    margin: 0;
    font-size: 11px;
    font-weight: 800;
    color: ${COLORS.primary_color_shade9};
    text-transform: uppercase;
    letter-spacing: 0.04em;
    white-space: nowrap;
    padding: 4px 8px;
    border-radius: 6px;
    background: rgba(255,255,255,0.92);
    box-shadow: 0 1px 3px rgba(1, 87, 155, 0.15);
  }
  .mbs-filter__select {
    flex: 1;
    min-width: 0;
    padding: 7px 10px;
    font-size: 13px;
    border-radius: 8px;
    border: 2px solid rgba(255,255,255,0.65);
    background: #fff;
    font-weight: 700;
    color: ${COLORS.primary_color_shade9};
    outline: none;
  }
  .mbs-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));
    gap: 6px;
    max-height: 320px;
    overflow-y: auto;
    padding: 2px;
    background: #fff;
  }
  .mbs-card {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 42px;
    padding: 8px 10px;
    border-radius: 8px;
    border: 2px solid ${COLORS.primary_color_shade3};
    background: #fff;
    cursor: pointer;
    text-align: center;
    box-shadow: 0 1px 3px ${COLORS.primary_color_shade2}55;
    transition: all 0.15s ease;
  }
  .mbs-card:hover {
    border-color: ${COLORS.primary_color_shade5};
    background: ${COLORS.primary_color_shade1};
  }
  .mbs-card.is-selected {
    border-color: #2e7d32;
    background: linear-gradient(135deg, #66bb6a 0%, #43a047 55%, #2e7d32 100%);
    box-shadow: 0 0 0 2px rgba(46, 125, 50, 0.18);
  }
  .mbs-card__label {
    margin: 0;
    font-size: 12px;
    font-weight: 700;
    color: ${COLORS.primary_color_shade8};
    line-height: 1.25;
  }
  .mbs-card.is-selected .mbs-card__label {
    color: #fff;
    font-weight: 800;
  }
  .mbs-card__tick {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #fff;
    color: #2e7d32;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.16);
  }
  .mbs-empty {
    text-align: center;
    padding: 28px 12px;
    border-radius: 10px;
    border: 2px dashed rgba(179, 229, 252, 0.7);
    background: #f8fcff;
    color: #607d8b;
    font-size: 13px;
    font-weight: 600;
  }
  .mbs-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-height: 36px;
    padding: 6px 14px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 800;
    border: 2px solid transparent;
    cursor: pointer;
  }
  .mbs-btn:disabled { opacity: 0.55; cursor: not-allowed; }
  .mbs-btn--ghost {
    background: #fff;
    border-color: #b3e5fc;
    color: #0277bd;
  }
  .mbs-btn--ghost:hover:not(:disabled) { background: #e1f5fe; }
  .mbs-btn--primary {
    background: linear-gradient(135deg, #43a047 0%, #2e7d32 100%);
    border-color: #2e7d32;
    color: #fff;
  }
  @media (max-width: 640px) {
    .mbs-filters { grid-template-columns: 1fr; }
    .mbs-filter--medium { border-left: none; border-top: 2px solid rgba(255,255,255,0.35); }
  }
`;

//Created By Cursor
function buildFilteredClassSectionList(data, boardId, mediumId) {
  const filtered = [];
  const matched = (data || []).filter(
    (item) => String(item.board_id) === String(boardId) && String(item.medium_id) === String(mediumId)
  );
  matched.forEach((item) => {
    if (item.section === "No") {
      filtered.push({ ...item, section_id: "No" });
      return;
    }
    (item.section || []).forEach((section) => {
      filtered.push({
        ...section,
        board_id: boardId,
        board_name: item.board_name,
        medium_id: mediumId,
        medium_name: item.medium_name,
      });
    });
  });
  return filtered;
}

//Created By Cursor
function classCardLabel(item) {
  if (!item) return "—";
  if (item.section === "No" || item.section_id === "No" || !item.section_name) {
    return item.class_name || "—";
  }
  return `${item.class_name}:${item.section_name}`;
}

//Created By Cursor
const MdlBatchShift = ({ actionClose, actionSelectClass }) => {
  const sltBoardRef = useRef(null);
  const sltMediumRef = useRef(null);

  const [loggedIn] = useState(!!localStorage.getItem("token"));
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(true);
  const [sessionId, setSessionId] = useState("");
  const [sessionName, setSessionName] = useState("");
  const [classBoard, setClassBoard] = useState([]);
  const [classMedium, setClassMedium] = useState([]);
  const [mClassData, setMClassData] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [selectedPosition, setSelectedPosition] = useState(-1);

  useEffect(() => {
    if (document.querySelector("style[data-mdl-batch-shift='1']")) return;
    const styleTag = document.createElement("style");
    styleTag.setAttribute("data-mdl-batch-shift", "1");
    styleTag.textContent = DIALOG_STYLES;
    document.head.appendChild(styleTag);
  }, []);

  //Created By Cursor
  const applyFilter = useCallback((data) => {
    const source = data || mClassData;
    if (!sltBoardRef.current || !sltMediumRef.current) {
      setFilteredList([]);
      return;
    }
    const boardId =
      sltBoardRef.current.selectedOptions[0]?.getAttribute("board_id");
    const mediumId =
      sltMediumRef.current.selectedOptions[0]?.getAttribute("medium_id");
    if (!boardId || !mediumId) {
      setFilteredList([]);
      return;
    }
    const next = buildFilteredClassSectionList(source, boardId, mediumId);
    setFilteredList(next);
    setSelectedPosition(-1);
  }, [mClassData]);

  //Created By Cursor
  const loadClasses = useCallback(
    (nextSessionId) => {
      if (!nextSessionId) return;
      setLoading(true);
      axios
        .get(`${API_BASE()}getClass.php`, {
          params: {
            school_code: SessionManager.getSchoolCode(),
            session_id: nextSessionId,
          },
        })
        .then((res) => res.data)
        .then((response) => {
          if (response.api_status === "OK") {
            const classData = response.data.class || [];
            setMClassData(classData);
            setClassBoard(response.data.board || []);
            setClassMedium(response.data.medium || []);
          } else {
            myToast.notify_warning(response.api_remark);
          }
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.error("[MdlBatchShift] getClass error:", error);
          myToast.notify_warning("Failed to load classes.");
        });
    },
    []
  );

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${API_BASE()}getCurrentOrUpcomingSession.php`, {
        params: { school_code: SessionManager.getSchoolCode() },
      })
      .then((res) => res.data)
      .then((response) => {
        if (response.api_status === "OK" && response.data?.[0]) {
          const sid = response.data[0].session_id || "";
          setSessionId(sid);
          setSessionName(response.data[0].session_name || "");
          loadClasses(sid);
        } else {
          setLoading(false);
          myToast.notify_warning(
            response.api_remark || "No current/upcoming session found."
          );
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("[MdlBatchShift] session error:", error);
        myToast.notify_warning("Failed to load session.");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Apply filter after board/medium selects render with data
  useEffect(() => {
    if (classBoard.length > 0 && classMedium.length > 0 && mClassData.length > 0) {
      const timer = setTimeout(() => applyFilter(mClassData), 50);
      return () => clearTimeout(timer);
    }
  }, [classBoard, classMedium, mClassData, applyFilter]);

  //Created By Cursor
  const handleClose = () => {
    setShow(false);
    actionClose();
  };

  //Created By Cursor
  const handleBoardMediumChange = () => {
    setSelectedPosition(-1);
    applyFilter(mClassData);
  };

  //Created By Cursor
  const handleSubmit = () => {
    if (selectedPosition < 0 || !filteredList[selectedPosition]) {
      myToast.notify_warning("Select a destination class.");
      return;
    }
    const selected = filteredList[selectedPosition];
    actionSelectClass(
      selected.class_id,
      selected.section_id,
      selected.session_id || sessionId,
      selected.board_id,
      selected.medium_id
    );
  };

  if (!loggedIn) return <Redirect to="/Login" />;

  const selectedLabel =
    selectedPosition >= 0 ? classCardLabel(filteredList[selectedPosition]) : "";

  return (
    <Modal
      show={show}
      onHide={handleClose}
      animation={false}
      centered
      size="lg"
      dialogClassName="mdl-batch-shift-dialog"
      aria-labelledby="mdl-batch-shift-title"
    >
      <Modal.Header closeButton>
        <div className="mbs-title" id="mdl-batch-shift-title">
          <span className="mbs-title__icon" aria-hidden>
            <FaRandom />
          </span>
          <div>
            <div className="mbs-title__main">Select class to shift</div>
            <div className="mbs-title__sub">
              {sessionName
                ? `Session · ${sessionName}`
                : "Choose board, medium & destination class"}
            </div>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
        {loading ? (
          <div className="mbs-empty">
            <MyLoader />
          </div>
        ) : (
          <>
            <div className="mbs-filters">
              <div className="mbs-filter mbs-filter--board">
                <label className="mbs-filter__label" htmlFor="mbs-board">
                  Board
                </label>
                <select
                  id="mbs-board"
                  className="mbs-filter__select"
                  ref={sltBoardRef}
                  onChange={handleBoardMediumChange}
                >
                  {classBoard.map((item) => (
                    <option key={item.board_id} board_id={item.board_id}>
                      {item.board_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mbs-filter mbs-filter--medium">
                <label className="mbs-filter__label" htmlFor="mbs-medium">
                  Medium
                </label>
                <select
                  id="mbs-medium"
                  className="mbs-filter__select"
                  ref={sltMediumRef}
                  onChange={handleBoardMediumChange}
                >
                  {classMedium.map((item) => (
                    <option key={item.medium_id} medium_id={item.medium_id}>
                      {item.medium_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {filteredList.length === 0 ? (
              <div className="mbs-empty">No classes for this board/medium.</div>
            ) : (
              <div className="mbs-grid" role="listbox" aria-label="Classes">
                {filteredList.map((item, index) => {
                  const selected = selectedPosition === index;
                  return (
                    <button
                      key={`${item.class_id}-${item.section_id}-${index}`}
                      type="button"
                      role="option"
                      aria-selected={selected}
                      className={`mbs-card${selected ? " is-selected" : ""}`}
                      onClick={() => setSelectedPosition(index)}
                    >
                      {selected ? (
                        <span className="mbs-card__tick" aria-hidden>
                          <FaCheck />
                        </span>
                      ) : null}
                      <p className="mbs-card__label">{classCardLabel(item)}</p>
                    </button>
                  );
                })}
              </div>
            )}
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <button type="button" className="mbs-btn mbs-btn--ghost" onClick={handleClose}>
          <FaTimes aria-hidden /> Cancel
        </button>
        <button
          type="button"
          className="mbs-btn mbs-btn--primary"
          onClick={handleSubmit}
          disabled={selectedPosition < 0}
        >
          <FaCheck aria-hidden />
          {selectedLabel ? `Shift to ${selectedLabel}` : "Confirm shift"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default MdlBatchShift;
